import { usersEndpointIds } from 'root/src/shared/users/users.constants';
import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
export const getUserAdminEndpoint = {
    [usersEndpointIds.GET_USER_ADMIN]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        endpointType: otherEndpointType,
    },
};
